import { ICreateTeaser, IEditTeaser, IGetPaginatedTeasers } from 'types';
import {
	serviceGetTeaserInfo,
	serviceCreateTeaser,
	serviceUpdateTeaser,
	serviceGetPaginatedTeasers,
	serviceDeleteTeaser,
} from 'services/api/teasers';
import { createAppErrorMessage } from 'utils/helpers';

const getTeaserInfo = async (teaserID: string) => {
	try {
		const response = await serviceGetTeaserInfo(teaserID);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const createTeaser = async (data: ICreateTeaser) => {
	try {
		await serviceCreateTeaser(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorCreatingTeaser');
		throw new Error(errorMessage);
	}
};

const editTeaser = async (data: IEditTeaser) => {
	try {
		await serviceUpdateTeaser(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingTeaser');
		throw new Error(errorMessage);
	}
};

const getPaginatedTeasers = async (args: IGetPaginatedTeasers) => {
	try {
		const response = await serviceGetPaginatedTeasers(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const deleteTeaser = async (teaserID: string) => {
	try {
		await serviceDeleteTeaser(teaserID);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorDeletingTeaser');
		throw new Error(errorMessage);
	}
};

export { getTeaserInfo, createTeaser, editTeaser, getPaginatedTeasers, deleteTeaser };
